import storage from './storage';

export default {
    openid: storage.get(),
    jssdk: {},
};



// WEBPACK FOOTER //
// ./src/store/wechat/state.js